"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePropHouse = void 0;
const components_1 = require("../components");
const react_1 = require("react");
const usePropHouse = () => {
    const propHouse = (0, react_1.useContext)(components_1.PropHouseContext);
    if (!propHouse) {
        throw new Error(`You must provide a PropHouse instance via the PropHouseProvider`);
    }
    return propHouse;
};
exports.usePropHouse = usePropHouse;
